import Link from "next/link";
import Image from 'next/image';
import React, { useEffect } from "react";
import {toHTML} from '@portabletext/to-html';
import HomePageVideoModal from '@/components/HomePageVideoModal';

const HomeBanner = ({bannerHeading, bannerText, bannerImage, bannerVideoText, bannerVideoThumbnail, featuredResearchPaper, bannerVideo}:any) => {

  return (
    <>
      <div className="col-12">
        <div className="row banner-row d-none d-sm-none d-md-none d-lg-none d-xl-block">
          <div className="col-12 banner-col" style={{backgroundImage:`url(${bannerImage})`}}>
            <div className="container">
              <div className="row banner-content-row">
                <div className="col-12 col-sm-8 text-center">
                  <img className="blocks-img" src="/img/img-header-blocks-cropped.png" />
                </div>
                <div className="col-12 col-sm-4 banner-content-col">
                  <div className="content-container">
                    <h4 className="title title-font">{bannerHeading}</h4>
                    <p className="subtitle subtitle-font">{bannerText}</p>
                    {/*<a href="#" className="purple-btn medium-font">{{banner_button_text}}</a>*/}
                  </div>
                </div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-12 col-sm-6 offset-sm-1 banner-video-content-col">
                      <hr className="white-hr-top" />
                      <div className="banner-video-text" dangerouslySetInnerHTML={{__html: toHTML(bannerVideoText)}}>
                        {/* */}
                      </div>
                      <hr className="white-hr-bottom" />
                      <div className="row">
                        <div className="col-1">
                          <img src="/img/icon-page.png" />
                        </div>
                        <div className="col-6">
                          <p>{featuredResearchPaper?.title}</p>
                        </div>
                        <div className="col-4">
                          <a href={`https://cdn.sanity.io/files/26sxkmoh/production/${featuredResearchPaper.document.asset._ref.replace('file-','').replace('-pdf','.pdf')}?dl=${featuredResearchPaper.document.asset._ref.replace('file-','').replace('-pdf','.pdf')}`} className="btn download-btn purple-btn" download>DOWNLOAD</a>
                        </div>
                        <div className="col-12 regular-font white-text" dangerouslySetInnerHTML={{__html: toHTML(featuredResearchPaper?.abstract)}}>
                          {/* */}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 offset-sm-1 banner-video-video-col">
                      <HomePageVideoModal videoThumbnail={bannerVideoThumbnail} video={bannerVideo}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row banner-wave-row">
              <div className="col-12 banner-bottom-row">
                <img src="/img/white-sep-cropped.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* mobile banner */}
      <div className="col-12">
        <div className="row banner-row mobile-pages-banner d-block d-sm-block d-md-block d-lg-block d-xl-none">
          <div className="col-12 homepage-banner-col mobile-homepage-banner-col banner-col">
            <div className="container">
              <div className="row banner-content-row">
                <div className="col-12 col-sm-7 banner-content-col">
                  <div className="content-container">
                    <h4 className="title title-font">{bannerHeading}</h4>
                    <p className="subtitle subtitle-font">{bannerText}</p>
                    {/*<a href="#" className="purple-btn medium-font">{{banner_button_text}}</a>*/}
                  </div>
                </div>
                <div className="col-12 col-sm-4 offset-sm-1 banner-video-video-col">
                  <HomePageVideoModal videoThumbnail={bannerVideoThumbnail} video={bannerVideo}/>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 bottom-banner-col">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-6 banner-video-content-col mobile-banner-video-content-col">
                  <hr className="white-hr-top" />
                  <div className="banner-video-text mobile-banner-video-text" dangerouslySetInnerHTML={{__html: toHTML(bannerVideoText)}}>
                    {/* */}
                  </div>
                  <hr className="white-hr-bottom" />
                </div>
                <div className="col-12 col-sm-6 mobile-banner-video-col">
                  <div className="row">
                    <div className="offset-2 col-2 research-paper-img mobile-research-paper-img">
                      <img src="/img/icon-page.png"/>
                    </div>
                    <div className="col-12 col-sm-8 subtitle-font research-paper-title-col mobile-research-paper-title-col">
                      <p>{featuredResearchPaper?.title}</p>
                    </div>
                    <div className="col-12 col-sm-8 research-paper-title-col mobile-research-paper-title-col" dangerouslySetInnerHTML={{__html: toHTML(featuredResearchPaper?.abstract)}}>
                      {/* */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <a href={`https://cdn.sanity.io/files/26sxkmoh/production/${featuredResearchPaper.document.asset._ref.replace('file-','').replace('-pdf','.pdf')}?dl=${featuredResearchPaper.document.asset._ref.replace('file-','').replace('-pdf','.pdf')}`} className="btn download-btn purple-btn" download>DOWNLOAD</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeBanner;
